<template>
  <div>
    <div v-for="(value, key) in item" :key="key">
      
      <!--iterative rows-->
      <template v-if="typeof value === 'object' && value != null">
        <!--feature heading-->
        <v-row no-gutters>
          <v-col>
            <span class="meta-feature"><!--:class="Array.isArray(value)? 'meta-feature': 'meta-feature pb-1' ">-->
              {{ $te(`${lookup}.${key}.text`) ? $t(`${lookup}.${key}.text`) : key }}
            </span>
          </v-col>
        </v-row>

        <!-- Comparable Cases -->
        <div v-if="key==='comparable_cases'" class="pt-1">
          <template>
            <div v-for="level in Object.keys(value)" :key="level">
            <span class="meta-grouping pl-3 pb-1"> <!-- :key="`${level}-level`"-->
              {{ $te(`${lookup}.${level}`) ? $t(`${lookup}.${level}.text`) : level }}
            </span>
            <ul class="meta-value" ><!--:key="level"-->
              <li v-for="(linkObj, linkidx) in value[level]" :key="linkidx">
                <a v-if="linkObj.url" :href="linkObj.url" target="_blank"> {{ linkObj.text }} </a>
                <template v-else> {{ linkObj.text }} </template>
              </li>
            </ul>
          </div>
          </template>
        </div>

        <!--show as list-->
        <div v-else-if="Array.isArray(value) && value.length > 1" class="pt-1">
          <ul class="meta-value">
            <li v-for="(item, itemidx) in limitItems(value,key)" :key="itemidx">
              {{ $te(`${lookup}.${item}`) ? $t(`${lookup}.${item}`) : item }}
            </li>
          </ul>

          <!--show all button to hide long list (e.g [2016] HKCFI 1008, [1997] HKCFI 183 )-->
          <v-btn v-if="value.length>6" 
            @click="toggleShowDetail(key)"
            x-small text block color="link" class="mb-2"
          >
            <template v-if="showdetailKeys.includes(key)">
              <v-icon x-small class="mr-3"> mdi-chevron-triple-up </v-icon> {{ $t('btntxt.collapse')}}
            </template>
            <template v-else>
              <v-icon x-small class="mr-3">mdi-chevron-triple-down</v-icon> {{ $t('btntxt.showall') }}
            </template>
          </v-btn>
        </div>

        <!--show as single item list-->
        <v-row v-else-if="Array.isArray(value) && value.length === 1" no-gutters>
          <span class="meta-value pl-2 pt-1"> {{ $te(`${lookup}.${value[0]}`) ? $t(`${lookup}.${value[0]}`) : value[0] }} </span>
        </v-row>
       
        <!--show as table-->
        <v-row v-else no-gutters >
         <table cellpadding="0" class="meta-table" >
          <tbody>
            <tr v-for="(value2, key2) in value" :key="key2">
              <td class="pt-1">
                <span class="meta-feature-intable"> {{ $te(`${lookup}.${key2}.text`) ? $t(`${lookup}.${key2}.text`) :  key2 }} </span>
              </td>
              <td class="pt-1 text-right">
                <span class="meta-value" v-if="value2 != 0">
                  {{ $te(`${lookup}.${key2}.unit`) ? $tc(`${lookup}.${key2}.unit`, value2, {n: value2}) : 
                    $te(`${lookup}.${key}.default_unit`) ? $tc(`${lookup}.${key}.default_unit`, value2, {n: value2}) :
                    $te(`${lookup}.${value2}`) ? $t(`${lookup}.${value2}`) : value2
                  }} 
                </span>
                <span v-else class="meta-value"> <!--drug quantity = null-->
                  {{ $t(`${lookup}.unspecified`) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        </v-row>
      </template>
      
      <!--single row items-->
      <v-row v-else no-gutters>
         <table cellpadding="0" class="meta-table">
          <tbody>
            <tr>
              <td class="pt-1">
                <span class="meta-feature"> {{ $te(`${lookup}.${key}.text`) ? $t(`${lookup}.${key}.text`) : key }}</span>
              </td>
              <td class="pt-1  text-right">
                <span class="meta-value"> {{ 
                  $te(`${lookup}.${key}.unit`) ? $tc(`${lookup}.${key}.unit`, value, {n: value}) : 
                  $te(`${lookup}.${value}`) ? $t(`${lookup}.${value}`) : value }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </v-row>
      <v-divider role="presentation" class="mb-1"></v-divider>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'JudgmentKeyValue',
    props: {
      type: {type: String, required: true},
      item: {type: Object},
    },
    data(){
      return{
        showdetailKeys: [],
      }
    },
    methods:{
      limitItems(list, key) {
        const MAXLENGTH = 6
        return this.showdetailKeys.includes(key) ? list : list.slice(0, MAXLENGTH)
      },
      toggleShowDetail(key){
        if (this.showdetailKeys.includes(key)) {
          this.showdetailKeys = this.showdetailKeys.filter(k => k !== key)
        } else {
          this.showdetailKeys.push(key)
        }
      },
    },
    computed: {
      lookup(){ return `judinfobox.${this.type}`}
    }
  }
</script>

<style scoped lang="scss">
  .meta-feature{
    font-size: 0.78rem;
    font-weight: 600;
    word-break: normal;
    display: block;
    line-height: 1.18;
    color: var(--darkgrey-darken3);
  }
  .meta-feature-intable{
    font-size: 0.78rem;
    display: block;
    color: var(--v-darkgrey-darken1);
    line-height: 1.18;
    padding-left: 10px;
    padding-right: 4px;
    padding-bottom: 4px;
    word-break: break-word;
  }
  .meta-grouping{
    font-size: 0.78rem;
    font-style: italic;
    word-break: normal;
    display: block;
    color: var(--v-darkgrey-darken1);
    line-height: 1.18;
  }
  .meta-value{
    font-size: 0.78rem;
    word-break: keep-all;
    line-height: 1.18;
    display: block;
    padding-bottom: 4px;
    color: var(--v-darkgrey-darken3);
    list-style: none;
  }
  ul.meta-value {
    padding-left: 12px;
  }
  .meta-value li{
    text-indent: -10px;
    padding-top: 1px;
    padding-bottom: 4px;
  }
  .meta-value li:before{ /*bullet*/
    content: '– ';
    color: var(--v-darkgrey-lighten2);
    padding-left: -16px;
    position : relative;
    top: -.1rem;
  }

  /****type A - simple table***/
  .meta-table{
    width: 100%;
    border-spacing: 0px;
  }
  .meta-table tr td:first-child {
    white-space: normal;
    /*width: 1%;
    white-space: nowrap;*/
  }
  .meta-table tr td:last-child {
    white-space: pre-line;
    min-width: 65px;
    /*width: 1%;
    padding-right: 10px;*/
  }
  .meta-table td{
    vertical-align: top;
  }

  /**selection**/
  .selected-radio{
    background: var(--v-link-lighten5);
  }
</style>